import { InsightContentSettingType } from 'components/insightContent/types'
import AnalysisFilter from 'types/analysisFilter'
import { toFilter } from 'utils/widgetUtil'
import { SocialWebStoryScopeWidget as SocialWebStoryScopeWidgetType } from 'schemas/SocialWebStoryScopeWidgetSchema'
import { FilterTypeStrings } from 'enums/FilterType'
import { SearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/searchFilterComposingStrategy'
import { composeDetailSearchFilter } from 'utils/insightModal/composeDetailSearchFilter'
import LevelOneType from 'enums/LevelOneType'
import { WidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/widgetSettingComposingStrategy'
import { composeDrillDownWidgetSettingWithMultiStrategies } from 'utils/insightModal/composeDrillDownWidgetSettingWithMultiStrategies'
import { SelectedInsight } from './types'
import { getDisplayText } from '../StoryScope/utils/convertToSunburstData'

const buildTooltip = (selectedInsight: SelectedInsight) =>
  [selectedInsight.name || selectedInsight.stemmedForm].concat(selectedInsight.variants || [])

export const generateSelectedTerms = (
  selectedInsight: SelectedInsight,
  widgetSetting: SocialWebStoryScopeWidgetType,
  emojiNameToDisplayMap: any
) => {
  const levelOneTerm = selectedInsight.levelOneFilter && {
    name: selectedInsight.levelOneFilter,
    tooltip: selectedInsight.levelOneFilter
  }

  const nameTerm = {
    name: getDisplayText(selectedInsight.name!, widgetSetting.viewOption!, emojiNameToDisplayMap),
    tooltip: buildTooltip(selectedInsight)
      .map((name) => getDisplayText(name!, widgetSetting.viewOption!, emojiNameToDisplayMap))
      .join(', ')
  }
  if (
    widgetSetting.levelOneType === LevelOneType.SENTIMENT ||
    widgetSetting.levelOneType === LevelOneType.SENTIMENT_WO_NEUTRAL ||
    widgetSetting.levelOneType === LevelOneType.GENDER ||
    widgetSetting.levelOneType === LevelOneType.GENDER_WO_UNKNOWN
  ) {
    return [...(levelOneTerm ? [levelOneTerm] : []), nameTerm]
  }
  return [nameTerm]
}

export const convertToInsightContentSetting = (
  widgetSetting: SocialWebStoryScopeWidgetType,
  strategies: SearchFilterComposingStrategy[],
  selection?: { insights?: Array<SelectedInsight> },
  emojiNameToDisplayMap?: any
) => {
  const { viewOption } = widgetSetting

  const insightContentSetting = {
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos: widgetSetting.topicInfos!,
    drillDownTypes: [] as FilterTypeStrings[],
    drillDownFilter: {} as AnalysisFilter,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic?.topicId,
    insights: selection ? selection?.insights : null
  } as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  const insights = selection ? selection?.insights : null

  if (insights && insights.length > 0) {
    const selectedTerms = generateSelectedTerms(insights[0], widgetSetting, emojiNameToDisplayMap)

    insightContentSetting.selectionName = selectedTerms[0]?.name || ''
    insightContentSetting.selectionSecondName = selectedTerms[1]?.name

    insightContentSetting.selectionFilter = strategies.reduce(
      (accumulator, strategy) => ({
        ...accumulator,
        ...composeDetailSearchFilter(strategy, widgetSetting, insights)
      }),
      {} as any
    )
  }

  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: SocialWebStoryScopeWidgetType,
  strategies: WidgetSettingComposingStrategy[],
  selection: { insights?: Array<SelectedInsight> }
) => {
  if (!widgetSetting || typeof widgetSetting !== 'object') {
    return {}
  }

  if (!selection || !selection.insights || selection.insights.length === 0) {
    return {}
  }

  return composeDrillDownWidgetSettingWithMultiStrategies(
    strategies,
    widgetSetting,
    selection.insights!
  )
}
